import React, { useState, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Table } from "@components/Table";
import { ButtonSecondary, ButtonPrimaryLink } from "@components/Button";
import { deleteProductById } from "@actions/products.action";
import Modal from "@components/Modal";
import { Span } from "@styles/typography";
import { Row, Indent } from "@styles/grid";

const EditProduct = ({ productId }) => {
  const dispatch = useDispatch();
  const loading = useSelector(state => state.products.loading);

  const [isRemoveModalOpen, setIsRemoveModalOpen] = useState(false);

  const handleDeleteProduct = () => async () => {
    try {
      await dispatch(deleteProductById(productId));
      setIsRemoveModalOpen(false);
    } catch (error) {
      throw new Error(error.message);
    }
  };

  return (
    <Row justify="flex-end" padding="0 2rem 0 0">
      <Indent margin="0 1.5rem 0 0">
        <ButtonPrimaryLink uppercase href={`/products/${productId}`} outlined size="small" weight="bold">
          edit
        </ButtonPrimaryLink>
      </Indent>
      <ButtonSecondary uppercase onClick={() => setIsRemoveModalOpen(true)} size="small" weight="bold">
        Remove
      </ButtonSecondary>

      <Modal isOpen={isRemoveModalOpen} onClose={() => setIsRemoveModalOpen(false)} title="Remove Product">
        <Indent margin="4rem 0">
          <Span size={1.8}>Are you sure you want to delete this product?</Span>
        </Indent>
        <Row justify="flex-end">
          <Indent margin="0 2rem 0">
            <ButtonSecondary outlined onClick={() => setIsRemoveModalOpen(false)} uppercase>
              Close
            </ButtonSecondary>
          </Indent>
          <ButtonSecondary autoFocus onClick={handleDeleteProduct()} uppercase disabled={loading}>
            Remove
          </ButtonSecondary>
        </Row>
      </Modal>
    </Row>
  );
};

const ProductsTable = () => {
  const { products, fetching } = useSelector(({ products }) => products);

  const columns = useMemo(
    () => [
      {
        Header: "Name",
        accessor: "name",
        isFiltered: true,
        isSorting: true,
      },
      {
        Header: "Category",
        accessor: "category.name",
        isFiltered: true,
        isSorting: true,
      },
      {
        Header: "Brand",
        accessor: "brand.name",
        isFiltered: true,
        isSorting: true,
      },
      {
        Header: "Views",
        accessor: "views",
        isSorting: true,
      },
      {
        id: "colEdit",
        Cell: ({ row }) => <EditProduct productId={row.original.id} />,
      },
    ],
    []
  );

  const data = useMemo(() => products, [products]);

  return <Table columns={columns} data={data} hasGlobalFilter loading={fetching} />;
};

export default ProductsTable;
